// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToListModalStyles } from "@tps/Overrides/Components/ManageShareListModal";
import { modalButtonsActionStyles } from "@tps/XDL/Utilities";
import { mergeWithCss } from "@tps/XDL/Utilities/mergeWithCss";
import { css } from "styled-components";

addToListModalStyles.userTableHeader = {
    css: css`
        border: none;
    `,
};

addToListModalStyles.userCell = {
    ...mergeWithCss(addToListModalStyles.userCell, {
        css: css`
            font-size: 12px;
        `,
    }),
};

addToListModalStyles.buttonsWrapper = {
    ...modalButtonsActionStyles.buttonsGridItem,
};
